@for (field of fields; track field; let i = $index) {
  @if (deepValue(data, field.name)) {
    @if (field.label) {
      <span class="field-label">{{ field.label }}:</span>
    }
    <span class="field-value">
    {{ field.format ? field.format(deepValue(data, field.name)) : deepValue(data, field.name) }}</span>
    @if (i < propListLength - 1) {
      <span class="field-separator"
      >,&nbsp;</span>
    }
  }
}
